import DefaultLogoImage from "../../../../assets/default_logo.png";
import { jsx as _jsx } from "react/jsx-runtime";
const ipfsGateway = process.env.REACT_APP_IPFS_BASE_URL;
export function ProjectLogo(_ref) {
  let {
    logoImg
  } = _ref;
  const src = logoImg ? `${ipfsGateway}/ipfs/${logoImg}` : DefaultLogoImage;
  return /*#__PURE__*/_jsx("img", {
    className: "-mt-16 h-32 w-32 rounded-full ring-4 ring-white bg-white",
    src: src,
    alt: "Project Logo"
  });
}